// extracted by mini-css-extract-plugin
module.exports = {"header-middle-section":"HeaderMiddleSection_header-middle-section__ZcLbX"};